// Tras guardar algo que cambia el estado de la propiedad (publicar, retirar, vender, precios), las
// pantallas de renta y venta se actualizan solas en vez de recargar la página: quien guarda avisa
// con este evento y los hooks que leen la propiedad (`useAdminRent`, `useAdminSales`) la vuelven a pedir.
export const PROPERTY_REFRESH_EVENT = 'property:refresh';

export const refreshProperty = () => window.dispatchEvent(new Event(PROPERTY_REFRESH_EVENT));
